import React from 'react';
import { Link } from 'react-router-dom';
import Carousel1 from '../Images/Carousel1.jpg';
import Carousel2 from '../Images/Carousel2.jpg';
import Carousel3 from '../Images/Carousel3.jpg';

const CarouselSection = () => {
  return (
    <div>
      <div id="heroCarousel" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">
          {/* Slide 1 */}
          <div className="carousel-item active">
            <img
              src={Carousel1}
              className="d-block w-100 img-fluid"
              alt="IT Strategy"
            />
            <div className="carousel-caption position-absolute top-50 translate-middle-y text-start d-flex flex-column justify-content-center align-items-start p-3 p-md-5" style={{ left: '2vw' }}>
              <h3 className="display-6 text-light fw-bold" style={{ fontFamily: 'Roboto' }}>
                Empowering Your IT Vision
              </h3>
              <p className="mb-4 text-light">Strategic solutions tailored for business growth.</p>
              <div className="d-flex flex-wrap gap-2">
                <Link to="/services" className="btn-custom rounded-5">View Services</Link>
                <Link to="/contact" className="btn-outline-custom rounded-5">Connect With Us</Link>
              </div>
            </div>
          </div>

          {/* Slide 2 */}
          <div className="carousel-item">
            <img
              src={Carousel2}
              className="d-block w-100 img-fluid"
              alt="Cybersecurity"
            />
            <div className="carousel-caption position-absolute top-50 translate-middle-y text-start d-flex flex-column justify-content-center align-items-start p-3 p-md-5" style={{ left: '2vw' }}>
              <h3 className="display-6 text-light fw-bold" style={{ fontFamily: 'Roboto' }}>
                Secure, Scalable & Smart
              </h3>
              <p className="mb-4 text-light">Comprehensive cybersecurity and cloud services.</p>
              <div className="d-flex flex-wrap gap-2">
                <Link to="/services" className="btn-custom rounded-5">View Services</Link>
                <Link to="/contact" className="btn-outline-custom rounded-5">Connect With Us</Link>
              </div>
            </div>
          </div>

          {/* Slide 3 */}
          <div className="carousel-item">
            <img
              src={Carousel3}
              className="d-block w-100 img-fluid"
              alt="Digital Transformation"
            />
            <div className="carousel-caption position-absolute top-50 translate-middle-y text-start d-flex flex-column justify-content-center align-items-start p-3 p-md-5" style={{ left: '2vw' }}>
              <h3 className="text-light fw-bold display-6" style={{ fontFamily: 'Roboto' }}>
                Enabling Smarter, Stronger IT Futures
              </h3>
              <p className="mb-4 text-light">From consulting to implementation – we've got you covered.</p>
              <div className="d-flex flex-wrap gap-2">
                <Link to="/services" className="btn-custom rounded-5">View Services</Link>
                <Link to="/contact" className="btn-outline-custom rounded-5">Connect With Us</Link>
              </div>
            </div>
          </div>
        </div>

        {/* Controls */}
        <button
          className="carousel-control-prev custom-carousel-control"
          type="button"
          data-bs-target="#heroCarousel"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon custom-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next custom-carousel-control"
          type="button"
          data-bs-target="#heroCarousel"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon custom-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
};

export default CarouselSection;
